import React, { Component } from 'react';
import $ from "jquery";


class Saloncode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saloncode: "",
        }
    }

    componentDidMount = () => {
        document.querySelector(".settings").style.display = "none";
        this.height();
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }

    height = () => {
        let totalHeight = $(window).height();
        let heightHeader = $(".header").outerHeight();
        document.querySelector(".saloncode").style.height = (totalHeight - heightHeader) + "px";
    }
    
    resize = () => {
        this.height();
    }

    handleChange = (e) => {
        this.setState((prevState) => {
            prevState.saloncode = e.target.value;
            return prevState;
        });
    }

    getButtonClass = () => {
        let result = (this.props.isLoading) ? "button is-loading" : "button";
        return result;
    }

    onClickButton = (e) => {
        
    }

    renderInfo = () => {
        if (this.props.nSaloncode) {
            return (<p className="has-text-danger">
                        Salon code klopt niet!
                    </p>);
        }
    }
    
    render() {
        return (
            <div className="saloncode">
                <div className="card saloncode-card">
                    <div className="card-content">
                        <p className="title" style={{fontWeight: "900"}}>
                            Salon code
                        </p>
                        <p className="sub-title">
                            Informeer bij uw salon naar de juiste salon code
                        </p>
                        <div className="field">
                            <div className="cControl">
                                <input value={this.saloncode} onChange={this.handleChange} className="input mt-5" type="text" />
                            </div>
                        </div>
                        {this.renderInfo()}
                    </div>
                    <footer className="card-footer">
                        <p className="card-footer-item">
                        <button className={this.getButtonClass()} onClick={() => this.props.setSaloncode(this.state.saloncode)}>Bevestigen</button>
                        </p>
                    </footer>
                </div>
            </div>
        );
    }
}

export default Saloncode;